export default function Email(props: any) {
    return (
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect
                x="0.75"
                y="0.75"
                width="46.5"
                height="46.5"
                rx="3.82143"
                fill="url(#paint0_linear_941_8662)"
                stroke="url(#paint1_linear_941_8662)"
                strokeWidth="1.5"
            />
            <g filter="url(#filter0_i_941_8662)">
                <path
                    d="M34.9471 14.7143H12.5714C12.4499 14.7143 12.3314 14.7293 12.2178 14.7585L23.0557 25.5957C23.1896 25.7296 23.3713 25.8048 23.5607 25.8048C23.7501 25.8048 23.9317 25.7296 24.0657 25.5957L34.9471 14.7143ZM36.4921 15.1893L27.7635 23.9178L36.5671 32.7207C36.7492 32.4807 36.8571 32.1814 36.8571 31.8571V16.1428C36.8571 15.7764 36.7192 15.4428 36.4928 15.1893H36.4921ZM35.1114 33.2857L26.7542 24.9278L25.0757 26.6064C24.8767 26.8054 24.6404 26.9633 24.3804 27.071C24.1204 27.1787 23.8417 27.2342 23.5603 27.2342C23.2789 27.2342 23.0002 27.1787 22.7402 27.071C22.4802 26.9633 22.2439 26.8054 22.0449 26.6064L20.3671 24.9278L12.0928 33.2035C12.2428 33.2564 12.4035 33.2857 12.5721 33.2857H35.1121H35.1114ZM11.1649 32.11L19.3571 23.9171L11.1957 15.7571C11.1605 15.8827 11.1428 16.0125 11.1428 16.1428V31.8571C11.1428 31.9428 11.1499 32.0278 11.1649 32.11ZM12.5714 13.2857H35.4285C35.8037 13.2857 36.1753 13.3596 36.5219 13.5032C36.8685 13.6468 37.1835 13.8572 37.4488 14.1225C37.7141 14.3878 37.9246 14.7028 38.0682 15.0495C38.2118 15.3961 38.2857 15.7676 38.2857 16.1428V31.8571C38.2857 32.2323 38.2118 32.6039 38.0682 32.9505C37.9246 33.2971 37.7141 33.6121 37.4488 33.8774C37.1835 34.1427 36.8685 34.3532 36.5219 34.4968C36.1753 34.6404 35.8037 34.7143 35.4285 34.7143H12.5714C12.1962 34.7143 11.8246 34.6404 11.478 34.4968C11.1314 34.3532 10.8164 34.1427 10.5511 33.8774C10.2858 33.6121 10.0753 33.2971 9.93172 32.9505C9.78814 32.6039 9.71423 32.2323 9.71423 31.8571V16.1428C9.71423 15.7676 9.78814 15.3961 9.93172 15.0495C10.0753 14.7028 10.2858 14.3878 10.5511 14.1225C10.8164 13.8572 11.1314 13.6468 11.478 13.5032C11.8246 13.3596 12.1962 13.2857 12.5714 13.2857Z"
                    fill="black"
                />
            </g>
            <defs>
                <filter
                    id="filter0_i_941_8662"
                    x="6.85712"
                    y="6.85715"
                    width="34.2857"
                    height="35.4286"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                    <feOffset dy="1.14286" />
                    <feGaussianBlur stdDeviation="0.571429" />
                    <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                    <feBlend mode="normal" in2="shape" result="effect1_innerShadow_941_8662" />
                </filter>
                <linearGradient id="paint0_linear_941_8662" x1="48" y1="-28.5" x2="85.5184" y2="25.5533" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#E6E6E4" />
                    <stop offset="0.439272" stopColor="#9C9C9C" />
                    <stop offset="1" stopColor="white" />
                </linearGradient>
                <linearGradient id="paint1_linear_941_8662" x1="20.6695" y1="-15.077" x2="51.6366" y2="-14.1162" gradientUnits="userSpaceOnUse">
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#777777" />
                </linearGradient>
            </defs>
        </svg>
    );
}
